import { Trigger } from '@radix-ui/react-popover';

export type PopoverTriggerProps = React.ComponentPropsWithoutRef<typeof Trigger>;

const PopoverTrigger = Trigger;

export default PopoverTrigger;
